<svg width="16" height="16" fill="none" version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
 <rect x="1.3334" y="2" width="13.333" height="12" rx="2.6667" stroke="#16151C"/>
 <path d="m1.3334 4.6666 5.0008 4.0006c0.97391 0.77913 2.3578 0.77913 3.3317 0l5.0008-4.0006" stroke="#16151C" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
